if (!customElements.get('product-recommendations')) {
	const MEDIA_SELECTORS = [
		'.card-link > .card-media',
		'.card-link > .card__media',
		'a.card-link > .card-media',
		'a.card-link > .card__media',
		'.card-media',
		'.card__media',
		'.card-link > .ratio',
		'a.card-link > .ratio',
	];

	function findCardMedia(card) {
		for (const sel of MEDIA_SELECTORS) {
			const el = card.querySelector(sel);
			if (el) {
				return el;
			}
		}
		return null;
	}

	function enhanceRecommendationCards(root) {
		if (!root) {
			return;
		}

		root.querySelectorAll('.product-recommendations__grid .grid-item .card, .product-recommendations__grid .grid-item article.card, .product-recommendations__grid .grid-item product-card, .product-recommendations__grid .grid-item .card-product').forEach((card) => {
			const media = findCardMedia(card);
			const badge = card.querySelector('.badge-stock:not(.product-recommendations__media-badge)');
			if (!media || !badge || media.contains(badge)) {
				return;
			}
			media.classList.add('product-recommendations__media');
			media.appendChild(badge);
			badge.classList.add('product-recommendations__media-badge', 'card-product__media-badge');
		});
	}

	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) {
					return;
				}

				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');

						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}

						if (html.querySelector('.card')) {
							this.classList.add('product-recommendations-loaded');
						}

						enhanceRecommendationCards(this);
					})
					.catch((error) => {
						console.error(error);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
		}

		connectedCallback() {
			enhanceRecommendationCards(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);
}
